<div class="sidebar-container overflow-hidden">
    <div class="title">Mujoco Poses</div>
    <div class="content tryb-scroll">
        <ul class="pose-list" *ngFor="let pose of poseMappings">
            <li>
                <p class="element-name">{{ pose.name }}</p>
                <ul class="pos-list-element">
                    <li *ngIf="pose.qpos_range_position">
                        <p class="pose-category">Position</p>
                        <ul class="pos-list-element-value">
                            <li class="pose-value">
                                {{ pose.qpos_range_position }}
                            </li>
                        </ul>
                    </li>
                    <li *ngIf="pose.qpos_range_orientation">
                        <p class="pose-category">Orientation</p>
                        <ul class="pos-list-element-value">
                            <li class="pose-value">
                                {{ pose.qpos_range_orientation }}
                            </li>
                        </ul>
                    </li>
                    <li *ngIf="pose.qpos_range_joint">
                        <p class="pose-category">Joint Range</p>
                        <ul class="pos-list-element-value">
                            <li class="pose-value">
                                {{ pose.qpos_range_joint }}
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
    </div>
</div>
